import { FC } from 'react';
import { Wrap, WrapItem } from '@chakra-ui/react';

import Chip from 'components/_core/Chip';

import locales from '../locales';

export enum FilterState {
  Pending = 'pending',
  Finished = 'finished',
  None = 'none',
}

interface FiltersProps {
  onChange(selected: FilterState): void;
  selected: FilterState;
  pendingDisabled: boolean;
  finishedDisabled: boolean;
}

const Filters: FC<FiltersProps> = ({
  finishedDisabled,
  onChange,
  pendingDisabled,
  selected,
}) => {
  return (
    <Wrap marginBottom="space-32">
      <WrapItem key="pending">
        <Chip
          disabled={pendingDisabled || selected === FilterState.None}
          icon="clock"
          isActive={selected === FilterState.Pending}
          onClick={() => onChange(FilterState.Pending)}
        >
          {locales.pendingReferrals}
        </Chip>
      </WrapItem>
      <WrapItem key="finished">
        <Chip
          disabled={finishedDisabled || selected === FilterState.None}
          icon="gift"
          isActive={selected === FilterState.Finished}
          onClick={() => onChange(FilterState.Finished)}
        >
          {locales.finishedReferrals}
        </Chip>
      </WrapItem>
    </Wrap>
  );
};

export default Filters;
